if (process.env.NODE_ENV === "production") {
	if (typeof window !== "undefined") {
		const allowedHosts = ["mtg.august-extreme.link"];
		if (!allowedHosts.includes(window.location.hostname)) {
			window.location.replace(
				`https://mtg.august-extreme.link${window.location.pathname}${window.location.search}`
			);
		}
	}
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";

import "bootstrap/dist/js/bootstrap.min.js";
import 'bootstrap/dist/css/bootstrap.min.css';
import './style.css';

import { debugInfo } from '@MyLib/Debug/Debug.js';
import './data/localize/i18n.js';
import { SaveProvider } from './context/SaveContext.jsx';
import { AuthProvider } from './context/AuthContext.jsx';
import { FirestoreProvider } from './context/FirestoreContext.jsx';
import { AppProvider } from './context/AppContext.jsx';
import { App } from './App';

debugInfo();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<BrowserRouter>
			<AppProvider>
				<AuthProvider>
					<FirestoreProvider>
						<SaveProvider>
							<App />
						</SaveProvider>
					</FirestoreProvider>
				</AuthProvider>
			</AppProvider>
		</BrowserRouter>
	</React.StrictMode>
);
//root.render(<App />);
